import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Panel, Separator } from '@fluentui/react';
import { columnSelectContext } from '../Provider/columnSelectContext';
import { ColumnCheckBoxList } from './ColumnCheckBoxList';
import { ColumnSelectPanelFooter } from './ColumnSelectPanelFooter';
/**
 * A panel bound to the surrounding ColumnSelectProvider's context
 *
 * > You probably use this externally, but using the ColumnSelect component
 * > is probably going to be a lot easier.
 */
export const ColumnSelectPanel = ({ children = '', closeButtonAriaLabel = 'Close', description = 'Select the columns you want to see in the list', headerText = 'Column selector', labelCloseButton = 'Close', }) => {
    const { isOpen, setOpen } = useContext(columnSelectContext);
    return (_jsxs(Panel, Object.assign({ isOpen: isOpen, hasCloseButton: true, isLightDismiss: true, onLightDismissClick: () => setOpen(false), onDismiss: () => setOpen(false), headerText: headerText, closeButtonAriaLabel: closeButtonAriaLabel, isFooterAtBottom: true, onRenderFooter: () => (_jsx(ColumnSelectPanelFooter, { labelCloseButton: labelCloseButton })) }, { children: [description, _jsx(Separator, {}), _jsx(ColumnCheckBoxList, {}), children] })));
};
